import React,{useState} from 'react';
import Select from "react-select";
// import './dashboard.css';
import './gst.css';
import axios from 'axios';
import {monthWiseGstToServer} from  '../../../../services/process/migrations/migrationService.js';


function GST({hidden})
{
    const processedList = [{"source_name": 'Invoice_Salary_Report_CM'}]
    const pendingList = [{"source_name": 'Invoice_Salary_Report_CM'}]
    const [gstHidden, setGstHidden] = useState(true);
    const [inputMonth, setInputMonth] = useState(undefined);
    const [gstProcessedReport, setGstProcessedReport] = useState(processedList);
    const [gstPendingReport, setGstPendingReport] = useState(pendingList);
    const [processedReportLength, setProcessedReportLength] = useState(undefined);
    const [pendingReportLength, setPendingReportLength] = useState(undefined);
    const [getAccountType, setGetAccountType] = useState(undefined);
    const [BankOptionsList, setBankOptionsList] = useState(undefined);
    const [getBank, setGetBank] = useState(undefined);
    const customStyles = undefined;
    // const processedGstList = useState(gstProcessedReport);
    // const gstPendingReportList = useState(gstPendingReport);

    // console.log("hi processedGstList", processedGstList);


    function getSetInputMonth(data){
        setInputMonth(data);
        console.log(data);
    
    }
    function monthWisegst()
    {
        let payload = {
            month: inputMonth,
            name: "GST Consolidation Report"
        }

        var gstCredentials = monthWiseGstToServer();
        // console.log("brsCredentials", brsCredentials);

        axios.post(gstCredentials[1], payload, gstCredentials[0])
        .then(
            response => {
                console.log("Getting Month Wise GST!!!", response);
                let responseData = response["data"]; 

                console.log("responseData", responseData);
                if (responseData["Status"] === "Success")
                {
                    let gstDetails = responseData["gstProcessedReports"];
                    let gstPendingDetails = responseData["gstPendingReports"];
                    // let brsDetails = responseData["brsCount"]; 
                    console.log("gstDetails", gstDetails["data"].length);
                    setGstProcessedReport(gstDetails["data"]);
                    setGstPendingReport(gstPendingDetails["data"]);
                    setProcessedReportLength(gstDetails["data"].length);
                    setPendingReportLength(gstPendingDetails["data"].length);
                    setGstHidden(false);

                }
            }
            
        ).catch(
            error => {
                console.log("Error", error);
                alert("Error in Getting GST Details!!!");
            }
        );
    };
    console.log("gstProcessedReport", gstProcessedReport)

    const handleClick = () => {
        // Replace 'your_link_here' with the actual link you want to redirect to
        window.location.href = 'http://172.16.40.14:3250/consolidation_file_upload';
    };
    

    function gstProcessdReports()
    {
        // console.log("processedGstList", processedGstList);
        // console.log("gstProcessedReport", gstProcessedReport)
        // const processedGstListNew = processedGstList;
        // const gstPendingReportList = gstPendingReportList
        // console.log("processedGstList", processedGstList)
        

        return (
            <div className="gstrecentOrders">
                <div className="gstbanklayer gstoverflow "> 
                    <h6 style={{textAlign: "right"}}>Processed</h6>
                    <h6>Reports - {processedReportLength}</h6>
                    {gstProcessedReport.map(item => (
                        <div>
                        <div className="gstbankbox">
                            <table >
                                <tbody>
                                    <thead>
                                        {/* <tr>
                                            <td><img src={bankImages} alt="" height="100px" width="100px" /></td>
                                        </tr> */}
                                        
                                        <tr>
                                            <td>{item.source_name}</td>
                                        </tr>
                                    </thead>
                                </tbody>
                            </table>
                        </div> 
                        </div>
                    ))}
                </div>
                <div className="gstbanklayer1 gstoverflow"> 
                    <h6 style={{textAlign:"center"}}>Pending Reports - {pendingReportLength}</h6>
                    {gstPendingReport.map(item => (
                        <div>
                        <div className="gstbankbox1">
                            <table >
                                <tbody>
                                    <thead>
                                        {/* <tr>
                                            <td><img src={bankImages} alt="" height="100px" width="100px" /></td>
                                        </tr> */}
                                        
                                        <tr>
                                            <td>{item.source_name}</td>
                                        </tr>
                                    </thead>
                                </tbody>
                            </table>
                        </div> 
                        </div>
                    ))}
                </div>
            </div>
        );
    }



return (
    <div>
        <div hidden={hidden}>
        <div className="gstchartbox1">
                <div className="gstchart-box-layer">
                    <table style={{width:"35%",marginTop:"-12px"}}>
                    
                        <tbody>
                            <tr>
                                <td className="gstaddcontracttext">Month</td>
                                <td>:</td>
                                <td><input type="month" name="" onChange={(e) => {setInputMonth(e.target.value)}}/></td>
                              
                                <td><button style={{textAlign: "center",  border: ".1px solid #000055", color: "#ffffff", padding:"4px 16px", borderRadius: "15px", backgroundColor: "#024f9d"}} onClick={monthWisegst}>
                                    Search
                                </button>&nbsp;</td>
                                <td><button style={{textAlign: "center",  border: ".1px solid #000055", color: "#ffffff", padding:"4px 16px", borderRadius: "15px", backgroundColor: "#024f9d" }} onClick={handleClick}>
                                    Go
                                </button>&nbsp;</td>

                            </tr>
                            
                        </tbody>
                    
                    </table>
                    
                
                </div>
            </div>

            {/* secound layer */}
            <div className="gstchartbox" hidden = {gstHidden}>
                <div>
                        {/* <!-- bank box --> */}
                    
                        {/* <div> */}
                            {gstProcessdReports()}
                        {/* </div> */}
                        {/* <!-- chart --> */}
                        {/* <div className="banklayer">hi</div> */}
                </div>
            </div>   
            
        </div>
    </div>
        
        
    );
}

export default GST;